import {
  Component,
  inject,
  Input,
  ViewEncapsulation,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MenuService } from "../../services/menu.services";
import { MenuNode } from "../reordering";
import { KENDO_TOOLBAR } from "@progress/kendo-angular-toolbar";
import { CustomToolComponent } from "../mode-lecture/custom-tool/custom-tool.component";
import { ToolboxTypeComponent } from "../mode-lecture/toolbox-type/toolbox-type.component";
import { KENDO_EDITOR } from "@progress/kendo-angular-editor";

@Component({
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./content.component.css"],
  selector: "app-my-content",
  templateUrl: "./content.component.html",
  imports: [
    KENDO_TOOLBAR,
    CustomToolComponent,
    DatePipe,
    ToolboxTypeComponent,
    KENDO_EDITOR,
  ],
})
export class ContentComponent implements OnChanges {
  @Input() selectedItem: string | undefined;
  readonly menuService = inject(MenuService);
  readonly sanitizer = inject(DomSanitizer);
  swEdit = false;
  public value = "";
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedItem"]) {
      console.log("selectedItem =", this.selectedItem);
      console.log(this.menuService.selectedSubMenu());
    }
  }

  switchEdit(item: MenuNode) {
    if (!this.swEdit) {
      const swEdit = this.menuService.switchEdit(item.archiveId);
      if (swEdit) {
        this.value = item.type === "Texte" ? (item.bloc ?? "") : "";
      }
      this.swEdit = true;
    } else {
      const swEdit = this.menuService.switchEdit(item.archiveId);
      if (swEdit) {
        this.value = item.type === "Texte" ? (item.bloc ?? "") : "";
      }
      this.swEdit = false;
    }
  }

  sauvegarder(item: MenuNode) {
    console.log("SAVE", item.archiveId, this.value);

    if (item.type === "Texte") {
      this.menuService.sauvagerderTexte(item.archiveId, this.value);
      this.menuService.switchEdit(item.archiveId);
      this.swEdit = false;
    }
  }

  ajouter(item: MenuNode, swAjouterEnHaut: boolean) {
    const newId = this.menuService.ajouter(item.archiveId, swAjouterEnHaut);
    if (newId !== undefined) {
      this.menuService.switchEdit(newId);
      this.value = "";
    }
  }

  html(item: MenuNode): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(
      item.type === "Texte" ? (item.bloc ?? "") : "",
    );
  }
}
